/* Enhance the app's existing engraving choices without replacing its form logic. */
(() => {
  const root = document.getElementById('aep-buy');
  if (!root) return;
  function deduplicateDeliveryFields() {
    root.querySelectorAll('form.hdt-main-product-form').forEach(form => {
      const values = new Set();
      form.querySelectorAll('input[type="hidden"][name="properties[Estimated delivery]"]').forEach(input => {
        // Preserve distinct values rather than guessing which estimate is correct.
        if (values.has(input.value)) input.remove();
        else values.add(input.value);
      });
    });
  }
  root.addEventListener('submit', deduplicateDeliveryFields, true);
  function enhance() {
    deduplicateDeliveryFields();
    root.querySelectorAll('.pplr-free-laser-engraving-options').forEach(group => {
      const items = [...group.querySelectorAll('.pplr-drop-item')];
      if (!items.length) return;
      if (group.getAttribute('role') !== 'radiogroup') {
        group.setAttribute('role', 'radiogroup');
        group.setAttribute('aria-label', 'Free laser engraving options');
      }
      items.forEach(item => {
        const selected = item.classList.contains('active');
        item.setAttribute('role', 'radio');
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
        if (item.dataset.aepReady) return;
        item.dataset.aepReady = 'true';
        item.addEventListener('keydown', event => {
          if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault(); item.click();
          } else if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) {
            event.preventDefault();
            const step = ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1;
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (items.indexOf(item) + step + items.length) % items.length;
            items[index].click(); items[index].focus();
          }
        });
      });
    });
  }
  enhance();
  new MutationObserver(enhance).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
})();
